import { Tag } from 'src/services/tag/Tag';

export function getRelPathCopy(fullPath: string, tags: Tag[]): string {
  const newFullPath = fullPath + '-copy';

  if (tags.some((t) => t.fullPath === newFullPath)) {
    return getRelPathCopy(newFullPath + '-copy', tags);
  } else {
    return newFullPath.split('/').slice(-1)[0];
  }
}
